<template><div><h1 id="debi-note-erfassen" tabindex="-1"><a class="header-anchor" href="#debi-note-erfassen"><span>Debi-Note erfassen</span></a></h1>
<p>Debi-Note manuell erfassen — Debi-Note in manuellen Buchungen erfassen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Die Debinote erzeugt einen ein Debitor. Der Betrag dieser Buchung (Typ &quot;O&quot;) wird dem Debitorenkonto belastet (z.B. für manuelles Einbuchen eines Pro memoria-Postens).</p>
<h2 id="pfad" tabindex="-1"><a class="header-anchor" href="#pfad"><span>Pfad</span></a></h2>
<p>Buchhaltung → Manuelle Buchungen → Neue Debinote (Menü)</p>
<p><strong>Parameter</strong></p>
<dl>
<dt>Personen-ID</dt>
<dd>Adresse zu der die Debi-Note gebucht wird</dd>
<dt>Typ</dt>
<dd>Eine &quot;obligatorische Debi-Note&quot; einspricht einer &quot;vereinbarten Buchung&quot;, die &quot;freiwillige Debi-Note&quot; einer &quot;vereinnahmten Buchung&quot; (siehe <a class="link" href="../../manual/buchhaltung/debitorenverwaltung.html#buchungsprinzip" title="1.2.4. Verbuchungsprinzipien Warenhandel / Spende">Verbuchungsprinzipien Warenhandel/Spende</a>)<br>Das Erfassen einer freiwilligen Debi-Note entspricht dem Erfassen einer obligatorischen Debinote mit dem Unterschied, dass die Daten erst beim Bezahlen der freiwiligen Debinote effektiv gebucht werden und erst dann ist auch der Übertrag dieser Daten in die Finanzbuchhaltung möglich. Solange die freiwillige Debinote nicht bezahlt ist, existiert sie nur als &quot;Vermerk&quot; in den Manuellen Buchungen.</dd>
<dt>Fakturanummer</dt>
<dd>Bestehende Faktura auswählen oder neue Nummer eintragen</dd>
<dt>Betrag</dt>
<dd>Betrag eintragen</dd>
<dt>Währung</dt>
<dd>Fremdwährung</dd>
<dt>Valutadatum</dt>
<dd>Valutadatum der Buchung</dd>
<dt>Fälligkeitsdatum</dt>
<dd>Fälligkeit der Zahlung</dd>
<dt>Mandant</dt>
<dd>Der <a class="link" href="ft.refdata.tblmandant.html" title="Mandanten">Mandant</a> wird nur eingetragen, wenn er auf Grund der Konteneingabe nicht eindeutig feststellbar ist</dd>
<dt>Konto</dt>
<dd>Gem. Tabelle <a class="link" href="ft.refdata.konti.html" title="Konti">Konto</a></dd>
<dt>Kostenstelle</dt>
<dd>Gem. Tabelle <a class="link" href="ft.refdata.kst.html" title="Kostenstellen">Kostenstelle</a></dd>
<dt>Kostenträger</dt>
<dd>Gem. Tabelle <a class="link" href="ft.refdata.ktr.html" title="Kostenträger">Kostenträger</a></dd>
<dt>Zahlungsnummer</dt>
<dd>Frei definierbare Zahlungsnummer</dd>
</dl>
<h3 id="situationen-beim-erfassen-einer-debi-note" tabindex="-1"><a class="header-anchor" href="#situationen-beim-erfassen-einer-debi-note"><span>Situationen beim Erfassen einer Debi-Note</span></a></h3>
<table>
<thead>
<tr>
<th>Währung der Faktura</th>
<th>Auswirkung</th>
</tr>
</thead>
<tbody>
<tr>
<td>Landeswährung</td>
<td>Die Währung des Habenkontos der O-Buchung muss die Landeswährung sein. Der Landeswährungsbetrag muss grösser Null und der Fremdbetrag muss gleich Null sein.</td>
</tr>
<tr>
<td>Fremdwährung</td>
<td>Die Währung des Habenkontos sowie die Währung des Fremdbetrages muss die gewünschte Fremdwährung sein. Der Fremdwährungsbetrag muss in diesem Fall grösser Null sein. Der Betrag in der Landeswährung wird automatisch aus dem Frremdwährungsberag mit dem Kurs des Valutadatums umgerechnet.</td>
</tr>
</tbody>
</table>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<h2 id="welche-daten-werden-verwendet-input" tabindex="-1"><a class="header-anchor" href="#welche-daten-werden-verwendet-input"><span>Welche Daten werden verwendet? (Input)</span></a></h2>
<p>siehe oben</p>
<h2 id="welche-daten-werden-verandert-oder-erzeugt" tabindex="-1"><a class="header-anchor" href="#welche-daten-werden-verandert-oder-erzeugt"><span>Welche Daten werden verändert oder erzeugt?</span></a></h2>
<p>siehe oben</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.manbuch.html" title="Manuelle Buchung">Manuelle Buchungen</RouteLink></p>
</div></template>


